<template>
  <!-- 购物车弹窗 -->
  <el-dialog :title="isEdit ? '编辑购物车' : '加入购物车'" :visible.sync="cartDialogVisible" top="2vh" width="1400px">
    <product-property
        ref="productProperty"
        :product-list="productForm.details"
        @UpdateProductForm="updateProductForm"/>

    <span slot="footer" class="dialog-footer">
      <el-button @click="cartDialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirmAddToCart">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import ProductProperty from "./ProductProperty.vue";
  import { EventBus } from "@/util/eventBus";
  export default {
    name: "ProductAddToCart",
    components: { ProductProperty },
    data() {
      return {
        cartDialogVisible: false,
        isEdit: false,
        productForm: {
          pkid: "",
          materialID: "",
          materialName: "",
          price: 0,
          details: [],
          quantity: 1,
        },
      };
    },
    methods: {
      handleData(data, detailKey) {
        this.cartDialogVisible = true;
        if(!this.isEdit) {
          this.$nextTick(() => {
            this.$refs.productProperty.getRef().resetFields();
          });
        }
        
        // 设置产品基本信息
        const { [detailKey]: details, ...rest } = data || {};
        this.productForm.materialName = rest.materialName || "";
        this.productForm.materialID = rest.materialID || "";
        this.productForm.price = rest.price || 0;
        this.productForm.pkid = rest.pkid || "";
        // 创建新的details数组，避免修改原始data对象
        this.productForm.details = (details || []).map(item => {
          const newItem = { ...item };
          // 处理多选类型的默认值，将逗号分隔的字符串转成数组
          if (Number(newItem.valueType) === 1 && typeof newItem.propertyValue === "string") {
            newItem.propertyValue = newItem.propertyValue.split(",").filter(Boolean);
          }
          return newItem;
        });
       
      },
      openByProductId(product) {
        this.isEdit = false;
        // 添加时间戳参数，避免缓存
        return this.$http.get("basic", `materials/vo1/${product.materialID}`).then(res => {
          const { data } = res || {};
          this.handleData(data, "materialPropertyVOES");
        });
      },
      // 通过购物车ID打开弹窗
      openByCartId(row) {
        this.isEdit = true;
        this.productForm.quantity = row.quantity || 1;
        // 添加时间戳参数，避免缓存
        this.$http.get("basic", `sdShoppingcarts/${row.pkid}`).then(res2 => {
          const {data} = res2 || {};
          this.handleData(data, "detailVOList");
        });
      },
      updateProductForm(newForm) {
        this.productForm.details = newForm;
      },
      // 提交到购物车列表
      async confirmAddToCart() {
        // 验证产品属性
        this.$refs.productProperty.getRef().validate((valid) => {
          if (valid) {
            // 将产品添加到购物车列表
            this.$refs.productProperty.updateProductForm();
            const query = {
              materialID: this.productForm.materialID,
              materialName: this.productForm.materialName,
              price: this.productForm.price,
              quantity: this.productForm.quantity || 1,
              pkid: this.productForm.pkid || null,
              detailVOList: this.productForm.details.map(item => ({
                ...item,
                propertyValue: item.valueType === 1 && Array.isArray(item.propertyValue) ? item.propertyValue.join(",") : item.propertyValue,
              })),
            };
            this.$http.post("basic", "sdShoppingcarts/save", query).then(res => {
              this.cartDialogVisible = false;
              // 触发购物车列表刷新事件
              EventBus.$emit("cart-list-refresh");
              this.$message.success(this.isEdit ?  `${this.productForm.materialName} 已更新` : `${this.productForm.materialName} 已加入购物车`);
            });
          }
        });
      },
    },
  };
</script>
